import { ISidebarMenuItem } from '@/nexus/components/admin-layout/SidebarMenuItem'

export const adminMenuItems: ISidebarMenuItem[] = [
  { id: 'overview-label', isTitle: true, label: 'Overview' },
  { id: 'dashboard', icon: 'lucide--layout-dashboard', label: 'Dashboard', url: '/dashboard' },
  { id: 'analytics', icon: 'lucide--chart-no-axes-combined', label: 'Analytics', url: '/analytics' },

  { id: 'conversations-label', isTitle: true, label: 'Conversations' },
  { id: 'sessions', icon: 'lucide--messages-square', label: 'Sessions', url: '/sessions' },
  { id: 'help-bot-sessions', icon: 'lucide--life-buoy', label: 'Help Bot Sessions', url: '/help-bot-sessions' },
  { id: 'feedback', icon: 'lucide--message-circle-heart', label: 'Feedback', url: '/feedback' },
  { id: 'downvotes', icon: 'lucide--thumbs-down', label: 'Downvotes', url: '/downvotes' },
  { id: 'uat-sessions', icon: 'lucide--activity', label: 'UAT Sessions', url: '/system' },
  { id: 'uat-survey', icon: 'lucide--clipboard-list', label: 'UAT Survey', url: '/uat-survey' },

  { id: 'access-label', isTitle: true, label: 'Access & Orgs' },
  { id: 'organizations', icon: 'lucide--building-2', label: 'Organizations', url: '/organizations' },
  { id: 'email-organizations', icon: 'lucide--mail', label: 'Email Orgs', url: '/email-organizations' },
  { id: 'users', icon: 'lucide--users', label: 'Users', url: '/users' },
  { id: 'rate-limits', icon: 'lucide--gauge', label: 'Rate Limits', url: '/rate-limits' },
  { id: 'access-blocks', icon: 'lucide--shield-ban', label: 'Blocked access', url: '/access-blocks' },

  { id: 'content-label', isTitle: true, label: 'Content' },
  { id: 'source-of-truth', icon: 'lucide--book-check', label: 'Source of Truth', url: '/source-of-truth' },
  { id: 'terms-of-service', icon: 'lucide--scroll-text', label: 'Terms of Service', url: '/terms-of-service' },
  // The free-trial disclosure. A separate document from the Terms of Service
  // above: that one is currently switched off, while this is the one readers
  // actually see. The page and its route already existed and were reachable
  // from the other layout's nav — it was simply missing here, so the only way
  // to edit the live text was to know the URL.
  { id: 'disclaimer', icon: 'lucide--file-text', label: 'Freemium Terms of Service', url: '/disclaimer' },

  { id: 'system-label', isTitle: true, label: 'System' },
  { id: 'settings', icon: 'lucide--settings', label: 'Settings', url: '/settings' },
]
